import React from "react";
import { Row, Col, Card } from "react-bootstrap";
import "../services/NewServices.css";

const ITServices = () => {
  const consultingServices = [
    {
      title: "IT Strategy and Digital Transformation",
      description: "Comprehensive IT strategy aligned with business goals"
    },
    {
      title: "Product Management and Development",
      description: "End-to-end product lifecycle management"
    },
    {
      title: "Technology and Architecture",
      description: "Design and implement scalable technology architectures"
    },
    {
      title: "Software, Platform and Solution Development",
      description: "Custom software and platform development services"
    },
    {
      title: "Application Modernization",
      description: "Modernize legacy applications and systems"
    },
    {
      title: "Infrastructure and Cloud Solutions",
      description: "Cloud migration and infrastructure optimization"
    }
  ];

  return (
    <div className="new-services-container">
      {/* Hero Section */}
      <div className="services-hero-banner">
        <div className="services-hero-content">
          <h1 className="services-hero-title">IT Consulting Services</h1>
          <p className="services-hero-description">
            Encycdata can help any business to achieve digital transformation journey. 
            We have people, process and technology expertise and partner ecosystem to address 
            challenges in adopting disruptive technologies and achieve Time-To-Market objectives.
          </p>
        </div>
      </div>

      <div className="services-content-wrapper">
        {/* IT Consulting Services Section */}
        <div className="services-section consulting-section">
          <Row className="consulting-services-row">
            {consultingServices.map((service, index) => (
              <Col md={4} sm={6} key={index} className="consulting-service-col">
                <Card className="consulting-service-card">
                  <Card.Body>
                    <h4 className="consulting-service-title">{service.title}</h4>
                    <p className="consulting-service-description">{service.description}</p>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      </div>
    </div>
  );
};

export default ITServices;

